import { Delete, Edit } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { EEntityType, entityTypeToLink } from '@sharedInterfaces/globalEnums';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './BusinessCard.css';
import { BusinessDialog } from '@src/App/Components/Dialogs/BusinessDialog/BusinessDialog';
import { useDialog } from '@src/App/Components/Dialogs/DialogManager';
import ExpandableText from '@src/App/Components/General/ExpandableText/ExpandableText';
import FormatedTextInput from '@src/App/Components/General/FormularElements/formsControls/inputs/FormatedTextInput/FormatedTextInput';
import type Business from '@src/Objects/Business';

import CardBox from '../../../CardBox/CardBox';

interface BusinessCardProps {
    business: Business;
    selected?: boolean;
    onSelectChange?: (state: boolean) => void;
}

/**
 * Renders a BusinessBox component.
 *
 * @param {BusinessCardProps} props - The properties for the BusinessBox component.
 * @returns {JSX.Element} The rendered BusinessBox component.
 */
function BusinessCard(props: BusinessCardProps) {
    const { openDialog } = useDialog();
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).businesses;
    const navigate = useNavigate();
    const business = props.business;
    return (
        <CardBox
            menu={
                <div>
                    <MenuItem
                        onClick={() => {
                            return openDialog(<BusinessDialog id="BusinessDialog" business={business} />);
                        }}
                    >
                        <ListItemIcon>
                            <Edit />
                        </ListItemIcon>
                        <ListItemText>{langStrings.edit}</ListItemText>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            business.delete();
                        }}
                    >
                        <ListItemIcon>
                            <Delete />
                        </ListItemIcon>
                        <ListItemText>{langStrings.delete}</ListItemText>
                    </MenuItem>
                </div>
            }
            onSelectChange={props.onSelectChange}
            selected={props.selected}
            title={business.title}
            className={'businessBox'}
            onClick={() => {
                navigate(entityTypeToLink(business.id, EEntityType.BUSINESS));
            }}
        >
            <ExpandableText>
                <>
                    {langStrings.description + ': '}
                    <FormatedTextInput value={business.description} readonly={true} />
                </>
            </ExpandableText>
        </CardBox>
    );
}

export default BusinessCard;
